import { render } from "./CameraOverlayCanvas.vue?vue&type=template&id=242ad8f4&scoped=true"
import script from "./CameraOverlayCanvas.vue?vue&type=script&lang=js"
export * from "./CameraOverlayCanvas.vue?vue&type=script&lang=js"

import "./CameraOverlayCanvas.vue?vue&type=style&index=0&id=242ad8f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-242ad8f4"]])

export default __exports__